import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import axios from "axios"

const originalFetch = window.fetch;
window.fetch = function(url, options = { default: false }) {
  if(!options.default) return originalFetch.call(this, url, options);

  if (url.startsWith('/')) {
    url = process.env.REACT_APP_BACKEND_URI + url;
  }
  
  options.headers = {
    ...options.headers,
    'App-Instance': process.env.REACT_APP_INSTANCE
  };
  
  return originalFetch.call(this, url, options);
};

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URI;
axios.defaults.headers.common['App-Instance'] = process.env.REACT_APP_INSTANCE;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter> 
    <App />
  </BrowserRouter>
);
reportWebVitals();
